// extracted by mini-css-extract-plugin
module.exports = {"flatTableOfContents":"TableOfContentsFlat-module--flatTableOfContents--3boQk"};